export const setStickySectionsTop = () => {
  let totalHeight = 0;

  // Start with the element having ID 'navigation'
  const navigation = document.getElementById('navigation');
  if (navigation) {
    navigation.style.top = `${totalHeight}px`;
    totalHeight += navigation.offsetHeight;
  }

  // Then, iterate through the rest of the elements with the 'sticky' class
  const stickyElements = document.querySelectorAll('.sticky');
  stickyElements.forEach(el => {
    if (el.id !== 'navigation') {
      el.style.top = `${totalHeight}px`;
      totalHeight += el.offsetHeight;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/components/sticky-sections.js